<template>
  <div>
    <div :class="is_mobile ? 'this-form-is-mobile' : ''">
      <v-form v-model="form">
        <v-row
          dense
          v-for="(row,row_index) in parsed_fields"
          :key="row.map((f) => f.id).join('|')"
          class="dynamicform-row"
          :class="is_mobile ? 'this-input-is-mobile' : ''"
        >
          <v-col
            v-for="(field,col_index) in row"
            :key="field.id+col_index"
            :cols="forced_cols || field.cols"
            class="dynamicform-col"
            :class="field.hidden ? 'dynamicform-hidden-col' : ''"
          >
            <div style="position: relative;" class="qmkey-form-input-field-unclickable">
              <div>
                <CustomInput
                  :field="field"
                  class="no_click"
                />
              </div>
              <div
                v-if="!readonly"
                class="qmkey-form-input-actions pb-6"
              >
                <div style="width: 75%; height: 100%;" class="qmkey-form-input-button right">
                  <v-icon
                    @click="modify_field(row_index,col_index)"> mdi-pencil </v-icon>
                </div>
                <div style="width: 25%; height: 100%;" class="qmkey-form-input-button left">
                  <DeleteButton
                    v-if="!readonly"
                    title="Delete Field"
                    :text="field.placeholder"
                    custom_icon="mdi-trash-can-outline"
                    @submit="delete_item(row_index,col_index)"
                  >
                    <template v-slot:content>
                      <v-row
                        dense
                        class="w-100 pa-2"
                      >
                        <v-col
                          :cols="12"
                        >
                          <CustomInput
                            :field="field"
                            class="no_click"
                          />
                        </v-col>
                      </v-row>
                    </template>
                          
                  </DeleteButton>
                </div>
              </div>
            </div>
          </v-col>
          <v-col v-if="!readonly && row.length > 0 && !(max_row_space(row) <= 0)"> 
            <v-btn
              icon
              @click="new_field(row_index,max_row_space(row))"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="!readonly">
            <v-btn
              icon
              @click="new_field(fields.length,12)"
              fab
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-row>
            <AddFormItem
              v-if="!readonly"
              hide_button
              :open="open"
              :fields="field_to_modify.data"
              @close="close_modal"
              @submit="update"
            />
      </v-form>
    </div>
  </div>
</template>


<style lang="scss">
  .no_click {
    pointer-events: none;
  }
  .qmkey-form-input-actions {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
  }
  .qmkey-form-input-button {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(0,0,0,0.1);
    display: none;
  }
  .qmkey-form-input-actions:hover > .qmkey-form-input-button, .qmkey-form-input-button:hover {
    display: inline-flex;
  }

  .this-form-is-mobile {
    justify-content: center;
    display: flex;
  }
  .qmkey-form-input-field-unclickable:hover > .qmkey-form-input-field-unclickable, .qmkey-form-input-field-unclickable-input {
    opacity: 0.33;
  }
</style>


<script>
  import CustomInput from '@/components/inputs/CustomInput.vue';
  import AddFormItem from '@/components/bpcreator/model/AddFormItem';
  import LangSelector from '@/components/header/LangSelector';
  import DeleteButton from '@/components/DeleteButton';


export default {
  components: {
    CustomInput,
    AddFormItem,
    LangSelector,
    DeleteButton,
  },

  name: 'FormInput',

  props: ['raw_fields','parsed_fields','bp','readonly','is_mobile','lang'],

  data: () => ({
    form: null,
    values: {},
    open: false,
    field_to_modify: {},
    empty_form: [[{}]],
  }),

  computed: {
    fieldlist() {
      // Returns a list with all fields [field1, field2...]
      return this.parsed_fields.flat();
    },
    is_valid() {
      return this.form;
    },
    forced_cols() {
      return this.is_mobile ? 12 : 0;
    },
    fields() {
      return this.parsed_fields.length > 0 ? this.parsed_fields : this.empty_form ;
    },
  },

  beforeMount() {
    for (const field of this.fieldlist) {
      this.values[field.id] = field.value;
    }
  },

  methods: {
    modify_field(row,col) {
      const row_unused_cols = 12-(this.parsed_fields[row].reduce((accumulator, currentValue) => accumulator + currentValue.cols, 0))
      const current_field = {...this.raw_fields[row][col]}
      this.field_to_modify.row = row;
      this.field_to_modify.col = col;
      this.field_to_modify.data = this.fields_to_colect(current_field.cols+row_unused_cols,current_field);
      this.open_modal();
    },

    new_field(row,max_cols) {
      this.field_to_modify.row = row || 0;
      this.field_to_modify.col = (this.raw_fields[row] || []).length || 0;
      this.field_to_modify.data = this.fields_to_colect(max_cols || 12);
      this.open_modal();
    },

    open_modal() {
      if (!this.readonly) {
        this.open = true;
      }
    },

    close_modal() {
      this.open = false;
    },

    fields_to_colect(max_cols,field) {
      return [
          [// Espacio
            {
              id: 'espacio',
              cols: 12,
              component: 'Tag',
              class: 'qmkey-view-title',
              label: 'Espacio',
            },
          ],
        [
            {
              id:	"cols",
              label: "Espacio",
              required: true,
              value: (field || {}).cols || 1,
              cols:	3,
              class: null,
              component: "NumericInput",
              placeholder: "Espacio",
              min: 1,
              max: max_cols || 0,
            },],
          [// Campos
            {
              id: 'campos',
              cols: 12,
              component: 'Tag',
              class: 'qmkey-view-title',
              label: 'Campos',
            },
          ],
          [// Input
            {
              id: 'tag_1',
              cols: 12,
              component: 'Tag',
              class: 'overline',
              label: 'Input',
            },
          ],
          [
            {
              id:	"id",
              label: "Id",
              required: false,
              value: (field || {}).id,
              items: Object.keys((this.bp || {}).raw.model || {}) || [],
              cols:	3,
              class: null,
              component: "Select",
              placeholder: "Id",
            },
          ],
          [
            {
              id:	"required",
              label: "Required",
              required: false,
              value: (field || {}).required,
              cols:	2,
              class: null,
              component: "CheckboxInput",
              placeholder: "Required",
            },
          ],
          [
            {
              id:	"is_inicial",
              label: "Is Inicial",
              required: false,
              value: (field || {}).is_inicial,
              cols:	2,
              class: null,
              component: "CheckboxInput",
              placeholder: "Is Inicial",
            }
          ],
          [// Input tag
            {
              id: 'tag_2',
              cols: 12,
              component: 'Tag',
              class: 'overline',
              label: 'Tag',
            }
          ],
          [
            {
              id:	"is_tag",
              label: "Is Tag",
              required: false,
              value: (field || {}).type == "BPTagField",
              cols:	2,
              class: null,
              component: "CheckboxInput",
              placeholder: "",
            },
          ],
          [
            {
              id:	"name",
              label: "Name",
              required: false,
              value: (field || {}).name || null,
              cols:	3,
              class: null,
              component: "DictInput",
              placeholder: "",
            },
          ],
          [
            {
              id:	"class",
              label: "Class",
              required: false,
              value: (field || {}).class || null,
              cols:	3,
              class: null,
              component: "TextInput",
              placeholder: "",
            },
          ],
        ]
    },

    update(value) {
      let boolean_values = {'id': value.id || null,'required': value.required == 'true', 'is_inicial': value.is_inicial == 'true', 'cols': parseInt(value.cols)};

      // Tag fields
      if (value.is_tag) {
        boolean_values.type = "BPTagField"
      }
      const result = {...value,...boolean_values};
      let new_form_fields = this.raw_fields.length > 0 ? [...this.raw_fields] : [];

      if (this.field_to_modify.row >= this.raw_fields.length) {
        new_form_fields.push([result]);
      } else {
        new_form_fields[this.field_to_modify.row][this.field_to_modify.col] = result;
      }

      this.$emit('update',new_form_fields);
      this.close_modal();
    },

    delete_item(row,col) {
      let new_fields = [...this.raw_fields];
      let new_row = new_fields[row];
      //Just remove 1 item
      new_row.splice(col,1);
      new_fields[row] = new_row;
      this.$emit('update',new_fields);
    },

    max_row_space(row) {
      return 12-(row.reduce((accumulator, currentValue) => accumulator + currentValue.cols, 0))
    },
  },
  watch: {
    is_valid(val) {
      this.$emit('ready', val);
    },
  },
}
</script>


